import React, { useEffect, useMemo, useState } from 'react';
import ReconciliationFilter from "./ReconciliationFilter"
import ReconciliationTable from "./ReconciliationTable"
import { useDispatch } from 'react-redux';
import { getReconciliationList } from '@src/store/slices/reconciliation';
import FullPageLoader from '@src/common/FullPageLoader';
import { getMasterConfig } from '../../src/store/slices/common';
import { getRoleListing } from '../../src/store/slices/RoleUser';
import {MANAGER_LEVEL_IDS,MAX_LEAD_ASSIGN_COUNT,COUNTRY_CODE,APP_COUNTRY} from '../config/constant'
import secureStorage from '../../src/config/encrypt';
import { toast } from "react-toastify";
import { useLanguage } from "../../src/context/LanguageContext";
import ConfirmPopUp from '../../src/common/ConfirmPopUp';
import LeadAssigneePopup from '../../src/lead/common/LeadAssignPopup';
import { bulkPaymentAssignee } from '@src/store/slices/reconciliation';
import * as HELPER from "@src/config/helper";
import ApplicationTypeChips, { getApplicationTypeMap, getFiltersWithApplicationType } from '@src/common/ApplicationTypeChips';

type OptionType = {
  value: number;
  label: string;
};

const RECON_VIEW_ROLE = "RECO_TEAM";
const reconciliationViewChips = [
  { key: 'all', label: 'All Reconciliation' },
  { key: 'my', label: 'My Reconciliation' },
];

const ReconciliationList: React.FC = () => {

  const dispatch: any = useDispatch();
  const [loading, setLoading] = useState<boolean>(false);
  const [paginationData, setPaginationData] = useState<any>({});
  const [reconciliationList, setReconciliationList] = useState<any>([]);
  const [selectedFilters, setSelectedFilters] = useState<any>({});
  const [paymentTypeList, setPaymentTypeList] = useState<any>([]);
  const [paymentMethodList, setPaymentMethodList] = useState<any>([]);
  const [reasonList, setReasonList] = useState<any>([]);
  const [assignUsers, setAssignedUsers] = useState<any>([]);
  // eslint-disable-next-line
  const [activeTab, setActiveTab] = useState<any>('all');
  const [masterConfig, setMasterConfig] = useState<any>({});
  const [selectedLeads, setSelectedLeads] = useState<any[]>([]);
  const authUserInfo = secureStorage.getItem("authUserInfo");
  const roleName = HELPER.normalizeRoleName(authUserInfo?.user_data?.assigned_role_name || "");
  const loggedInUserId = authUserInfo?.user_data?.id;
  const showReconciliationViewChips = roleName === RECON_VIEW_ROLE;
  const isPhApp = COUNTRY_CODE === APP_COUNTRY.APP_TYPE_PH;
  const [selectedReconciliationView, setSelectedReconciliationView] = useState<string>('my');
  const [selectedReconciliationApplicationType, setSelectedReconciliationApplicationType] = useState<string>('b2c');
  const [isAllLeadsSelected, setIsAllLeadsSelected] = useState<boolean>(false);
  const [showConfirmation,setShowConfirmation] = useState<boolean>(false);
  const [showLeadAssignPopup,setShowLeadAssignPopup] = useState<boolean>(false);
  const [agentId,setAgentId] = useState<number>(0);
  const { translations } = useLanguage();
  const reconciliationApplicationTypeMap = useMemo(() => getApplicationTypeMap(masterConfig), [masterConfig]);

  const statusFilterList: OptionType[] = [
      { value: 3, label: 'Pending' },
      { value: 1, label: 'Reconciled' },
      { value: 2, label: 'Rejected' }
  ]

  // const paymentTypeList: OptionType[] = [
  //     {"value": 1, "label": "Cheque"},
  //     {"value": 2, "label": "Trasaction"}
  // ];

  useEffect(() => {
    getMasterConfigApi();
    getReconciliationListing({});
    removeLocalStorage();
    getAssignedUsers();
    // eslint-disable-next-line
  }, [])

  const removeLocalStorage = () => {
    const prefix = 'recon_detail';
    for (let i = 0; i < localStorage.length; i++) {
      const key: any = localStorage.key(i);
      if (key.startsWith(prefix)) {
        localStorage.removeItem(key);
      }
    }
  }

    const getMasterConfigApi = () => {
      setLoading(true);
      dispatch(getMasterConfig()).then((res: any) => {
        if (res && res.status === 200) {
          if (res.data) {
            setMasterConfig(res.data);
            setPaymentTypeList(res.data['recon_payement_type']);
            setPaymentMethodList(res.data['payment_method']);
            if(res.data['reason_master']){
              let reason_master: any = res.data['reason_master'];
              const filteredReasons = reason_master
                .filter((item: any) => item.page === 1)
                .map((item: any) => ({ value: item.value, label: item.label }));
              setReasonList(filteredReasons);
            }
            
          }
        }
      }).catch((err: Error) => {
        setLoading(false);
      })
    }

  const getReconciliationViewFilters = (filters: Record<string, any> = {}, reconciliationView = selectedReconciliationView) => {
      const filtersWithView = { ...filters };

      if (!isPhApp || !showReconciliationViewChips) {
          return filtersWithView;
      }

      if (reconciliationView === 'my' && loggedInUserId) {
          filtersWithView.assign_user_id = loggedInUserId;
      } else {
          delete filtersWithView.assign_user_id;
      }

      return filtersWithView;
  };

  const getReconciliationViewChipCount = (chipKey: string) => {
      if (chipKey === 'all') {
          return paginationData?.final_total_payments ?? paginationData?.all ?? 0;
      }

      return paginationData?.my_payment_count ?? 0;
  };

  const getReconciliationApplicationTypeFilters = (filters: Record<string, any> = {}, applicationType = selectedReconciliationApplicationType) => {
      return getFiltersWithApplicationType(filters, applicationType, reconciliationApplicationTypeMap);
  };

  //GET RECONCILIATION LIST API
  const getReconciliationListing = (params: any,isCall=true, reconciliationView = selectedReconciliationView, applicationType = selectedReconciliationApplicationType) => {
      let filters = {
          page_number: params?.page_number ?? 1,
          isPaginationApply: true,
          activeTab,
          page: 'reco',
          ...params,
      }
      filters = getReconciliationViewFilters(filters, reconciliationView);
      filters = getReconciliationApplicationTypeFilters(filters, applicationType);
      setLoading(true)
      dispatch(getReconciliationList(filters)).then((res: any) => {
          setLoading(false)
          if (res && res.status === 200) {
              setPaginationData({ ...res.pagination })
              setReconciliationList([...res.data])
              if(isAllLeadsSelected && isCall){
                const allSelected: any[] = res.data.map((lead: any) => ({
                    id: lead.id
                }));
                setSelectedLeads(allSelected);
              }else{
                setSelectedLeads([]);
              }
          }
      }).catch((err: Error) => {
          setLoading(false)
      })
  }

  // const activeTabHandler = (tab: any) => {
  //   if (!tab) return;
  //   const activeTab = KEY_RECONCILIATION_ACTIVE_TAB_MAP[tab];
  //   if (activeTab) {
  //     setActiveTab(activeTab);
  //     getReconciliationListing({ page_number: 1, activeTab, ...selectedFilters });
  //   }
  // }

  const handleReconciliationViewChange = (reconciliationView: string) => {
    if (selectedReconciliationView === reconciliationView) return;
    setSelectedReconciliationView(reconciliationView);
    setSelectedLeads([]);
    setIsAllLeadsSelected(false);
    getReconciliationListing({ page_number: 1, activeTab, ...selectedFilters }, false, reconciliationView);
  }

  const handleReconciliationApplicationTypeChange = (applicationType: string) => {
    if (selectedReconciliationApplicationType === applicationType) return;
    setSelectedReconciliationApplicationType(applicationType);
    setSelectedLeads([]);
    setIsAllLeadsSelected(false);
    getReconciliationListing({ page_number: 1, activeTab, ...selectedFilters }, false, selectedReconciliationView, applicationType);
  }

  const getAssignedUsers = () => {
      dispatch(getRoleListing.getAssignedUsers({is_reco:true})).then((res: any) => {
          if (res && res.status === 200) {
              setAssignedUsers(res.data.map((user: any) => { return { label: user.firstname+" "+user.lastname, value: user.id,role_id:user.role_id,role_slug:user.role_slug } }));
          }
      }).catch((err: any) => {
          setLoading(false);
  
      })
  }

  const updateBulkAssignee = () => {
          try{
              if(selectedLeads.length === 0){
                  toast.error(translations.Insurance?.['NO_LEAD_SELECTED'] || translations.commonMsg?.loading);
                  return;
              }
              if(isAllLeadsSelected){
                  if(+paginationData.total > MAX_LEAD_ASSIGN_COUNT){
                      toast.error(`${translations.Insurance?.['MAX_ASSIGN_PAYMENT_LIMIT'] || translations.commonMsg?.loading} ${MAX_LEAD_ASSIGN_COUNT}`);
                      return;
                  }
              }
              setShowLeadAssignPopup(true);
          }catch (error) {
              console.error("Error In Update Assignee:", error);
          } finally {
              setLoading(false);
          }
      }

      const handleSubmit = async () => {
          try{
            let paylaod:any = {
              payment_type:'reco',
              assigned_user_id : +agentId,
              isAllLeadsSelected : isAllLeadsSelected,
              data_filter : getReconciliationApplicationTypeFilters(getReconciliationViewFilters(selectedFilters))
            };
            if(isAllLeadsSelected){
              paylaod.activeTab = activeTab;
            }else{
              paylaod.leads = selectedLeads
            }
            setLoading(true);
            const response:any = await bulkPaymentAssignee(paylaod);
            if (response?.status === 200) {
              setShowConfirmation(false)
              setSelectedLeads([]);
              setIsAllLeadsSelected(false);
              getReconciliationListing({ page_number: 1, activeTab, ...selectedFilters },false);
            }
          }catch (error) {
              console.error("Error while updating EMI detail:", error);
          }finally {
            // setLoading(false);
          }
      }

  return (
    <>
      <FullPageLoader show={loading} />
      {showLeadAssignPopup && <LeadAssigneePopup from={"reco"} showLeadAssignPopup={showLeadAssignPopup} setShowLeadAssignPopup={setShowLeadAssignPopup} assignUsers={assignUsers} setShowConfirmation={setShowConfirmation} setAgentId={setAgentId} userRoleLabel={'Reco team'}/>}
      {showConfirmation === false ? ("") : (
          <ConfirmPopUp
              confirmNo={() => {
                  setShowConfirmation(false);
                  setShowLeadAssignPopup(false);
                  setSelectedLeads([]);
              }}
              confirmYes={handleSubmit}
              message={`All the ${isAllLeadsSelected === false ? selectedLeads.length : ''} records will get updated. Do you wish to continue ?`}
              isConfirmNotVisible={true} 
              from={"reco"}
          />
      )}
      <div className="lead-list-outer container-fluid main-outer">
        <div>
          <div className="top-heading top-heading-btn">
            <h1>Reconciliation</h1>
            {MANAGER_LEVEL_IDS.includes(authUserInfo?.user_data?.assigned_role_ids) && 
                <div className='d-flex'>
                    <button className="btn-line btn-export" onClick={updateBulkAssignee}>
                        Update Assignee
                    </button>
                </div>
            }
            {/* <button className="btn-line btn-export">
              <i className="ic-save_alt m-sm-r"></i>
              Download Data
            </button> */}
          </div>

          <div className="loan-filter-bg">
            <div className="top-filter-bg">
              <ReconciliationFilter submitHandler={(filterParams: any) => { getReconciliationListing(filterParams) }} selectedFilters={selectedFilters} setSelectedFilters={setSelectedFilters} statusFilterList={statusFilterList} assignUsers={assignUsers} config={masterConfig}/>
            </div>
          </div>

          <div className="lead-list-table-outer">
            <ApplicationTypeChips
              selectedApplicationType={selectedReconciliationApplicationType}
              paginationData={paginationData}
              onChange={handleReconciliationApplicationTypeChange}
            />
            {isPhApp && showReconciliationViewChips && (
              <div className="lead-view-chip-outer">
                <span className="lead-view-label">VIEW</span>
                <div className="lead-view-chip-list">
                  {reconciliationViewChips.map((chip) => (
                    <button
                      key={chip.key}
                      type="button"
                      className={`lead-view-chip ${selectedReconciliationView === chip.key ? 'active' : ''}`}
                      onClick={() => handleReconciliationViewChange(chip.key)}
                    >
                      {chip.label}
                      <span>{getReconciliationViewChipCount(chip.key)}</span>
                    </button>
                  ))}
                </div>
              </div>
            )}
            <ReconciliationTable reconciliationList = {reconciliationList} paginationData={paginationData} getReconciliationListing={getReconciliationListing} selectedFilters={selectedFilters} statusFilterList={statusFilterList} paymentTypeList={paymentTypeList} paymentMethodList={paymentMethodList} reasonList={reasonList} assignUsers={assignUsers} selectedLeads={selectedLeads} setSelectedLeads={setSelectedLeads} setIsAllLeadsSelected={setIsAllLeadsSelected}/>

            {/* <Tab.Container id="lead-tabs" defaultActiveKey="first">
              <Nav variant="pills" className="flex-column nav nav-pills" onSelect={(k) => activeTabHandler(k)}>
                <div className="tab-list">
                  <Nav.Item>
                        <Nav.Link eventKey="first">
                            All <span>({(paginationData && paginationData['all']) || 0})</span></Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="second">
                            Pending <span>({(paginationData && paginationData['pending']) || 0})</span></Nav.Link>
                    </Nav.Item>

                    <Nav.Item>
                        <Nav.Link eventKey="third">
                            Verified <span>({(paginationData && paginationData['verified']) || 0})</span></Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="fourth">
                            Rejected <span>({(paginationData && paginationData['rejected']) || 0})</span></Nav.Link>
                    </Nav.Item>
                </div>
              </Nav>

              <Tab.Content>
                <Tab.Pane eventKey="first">
                  <ReconciliationTable reconciliationList = {reconciliationList} paginationData={paginationData} getReconciliationListing={getReconciliationListing} selectedFilters={selectedFilters} statusFilterList={statusFilterList} paymentTypeList={paymentTypeList} reasonList={reasonList} />
                </Tab.Pane>
                <Tab.Pane eventKey="second">
                  <ReconciliationTable reconciliationList = {reconciliationList} paginationData={paginationData} getReconciliationListing={getReconciliationListing} selectedFilters={selectedFilters} statusFilterList={statusFilterList} paymentTypeList={paymentTypeList} reasonList={reasonList}/>
                </Tab.Pane>
                <Tab.Pane eventKey="third">
                  <ReconciliationTable reconciliationList = {reconciliationList} paginationData={paginationData} getReconciliationListing={getReconciliationListing} selectedFilters={selectedFilters} statusFilterList={statusFilterList} paymentTypeList={paymentTypeList} reasonList={reasonList}/>
                </Tab.Pane>
                <Tab.Pane eventKey="fourth">
                   <ReconciliationTable reconciliationList = {reconciliationList} paginationData={paginationData} getReconciliationListing={getReconciliationListing} selectedFilters={selectedFilters} statusFilterList={statusFilterList} paymentTypeList={paymentTypeList} reasonList={reasonList}/>
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container> */}
          </div>
        </div>
      </div>
    </>

  );
};

export default ReconciliationList;
